import './index.css'
import {useState} from "react";
import StringHelper from "../../helpers/string-helper";

const BeforeLoading = ({transparent = false}) => {

    let initialValue = 'linear-gradient(0deg, #FF6A3C 0%, #FF4C3C 62%, #FF403C 100%)';
    const [storedValue] = useState(() => {
        try {
            // Get from local storage by key
            const item = window.localStorage.getItem('base:color');
            // Parse stored json or return initial value

            return initialValue;
            return item ? `linear-gradient(0deg, ${StringHelper.hexToRgba(item, 0.1)} 0%, ${StringHelper.hexToRgba(item, 0.6)} 62%, ${item} 100%)` : initialValue;
        } catch (error) {
            console.log(error);
            return initialValue;
        }
    });

    const [storeLogo] = useState(() => {
        try {
            // Get from local storage by key
            const item = window.localStorage.getItem('--tf-logo');
            // Parse stored json or return initial value
            return item || null;
        } catch (error) {
            console.log(error);
            return null;
        }
    });


    const [bgColor] = useState(() => {
        try {
            // Get from local storage by key
            return window.localStorage.getItem('bg') || '#1a191f'
            const item = window.localStorage.getItem('theme');
            // Parse stored json or return initial value
            return item === 'light' ? '#f2f2f2' : '#1a191f';
        } catch (error) {
            console.log(error);
            return initialValue;
        }
    });
    if (storeLogo && storeLogo !== 'undefined' && storeLogo !== undefined) {
        return <div style={{
            width: '100%',
            height: '100%',
            backgroundColor: transparent ? 'transparent' : bgColor,
            display: "flex",
            alignItems: 'center',
            justifyContent: 'center',
        }}>
        <span>
            <img style={{
                width: 180,
                objectFit: 'contain'
            }} className="blink-image" src={storeLogo}/>
        </span>
        </div>
    }

    return <div style={{
        width: '100%',
        height: '100%',
        backgroundColor: transparent ? 'transparent' : bgColor,
        display: "flex",
        alignItems: 'center',
        justifyContent: 'center',
    }}>
        <span className="">
            ...
        </span>
    </div>
}

export default BeforeLoading
